import React, { Component } from 'react';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';

class Results extends Component {
    render() {
        return (
            <div className="results">
                <div className="results__inner">
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <CommonTitle className="results__title">Результаты</CommonTitle>
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <CommonUsualText className="results__text">
                            Для всех рекламных кампаний отлично сработал таргетинг
                            на&nbsp;Look-alike аудиторию по&nbsp;имеющимся базам клиентов, ретаргет
                            на&nbsp;подписчиков сообщества и&nbsp;посетителей сайта BONUM
                            и&nbsp;на&nbsp;подписчиков групп, связанных с&nbsp;сельхозтехникой,
                            сельским хозяйством и&nbsp;грузоперевозками в&nbsp;Facebook*
                            и&nbsp;&laquo;ВКонтакте&raquo;.
                        </CommonUsualText>
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <CommonUsualText className="results__text">
                            Благодаря планомерной работе с&nbsp;гипотезами и&nbsp;подбору
                            оптимального распределения рекламного трафика по&nbsp;каналам, при
                            минимальном бюджете и&nbsp;постоянном мониторинге
                            за&nbsp;12&nbsp;месяцев команда &laquo;Вебпрактик&raquo; добилась
                            следующих результатов:
                        </CommonUsualText>
                    </ScrollAnimation>

                    <div className="results__wrapper">
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={100}
                            animateOnce={true}
                            duration={1}
                            className="results__card"
                        >
                            <div className="results__card-top">426</div>

                            <div className="results__card-bottom">
                                гипотез сгенерировано и&nbsp;проработано
                            </div>
                        </ScrollAnimation>

                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={100}
                            animateOnce={true}
                            duration={1}
                            className="results__card"
                        >
                            <div className="results__card-top">226</div>

                            <div className="results__card-bottom">
                                рекламных запусков в&nbsp;5&nbsp;разных каналах
                            </div>
                        </ScrollAnimation>

                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={100}
                            animateOnce={true}
                            duration={1}
                            className="results__card"
                        >
                            <div className="results__card-top">13,5%</div>

                            <div className="results__card-bottom">
                                общий рост качественных лидов
                            </div>
                        </ScrollAnimation>

                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={100}
                            animateOnce={true}
                            duration={1}
                            className="results__card"
                        >
                            <div className="results__card-top">6 560%</div>

                            <div className="results__card-bottom">
                                составил максимальный ROI по&nbsp;рекламной кампании
                            </div>
                        </ScrollAnimation>
                    </div>
                </div>
            </div>
        );
    }
}

export default Results;
